import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { HiDocumentText } from "react-icons/hi";
import { File_URL } from "../config/settings";
import { Link } from "react-router-dom";
import CorporateAproveDecline from "./CorporateAproveDecline";

const CorporateDocuploadModal = ({ corporateDetails }) => {
  const tagData2 = [
    {
      title: "Co7/CAC Certificate:",
      discription: "View Photo",
      data: corporateDetails?.co7CacForm?.certificates[0]?.fileAttach,
    },
    {
      title: "Company Profile:",
      discription: "View Photo",
      data: corporateDetails?.companyProfile,
    },
    {
      title: "Director Passport 1:",
      discription: "View Photo",
      data: corporateDetails?.directorPassport1,
    },
    {
      title: "Director Passport 2:",
      discription: "View Photo",
      data: corporateDetails?.directorPassport2,
    },
  ];

  return (
    <>
      <Box h={"60vh"} overflow={"scroll"}>
        {tagData2?.map((data, index) => (
          <Flex
            px={[1, null, null]}
            my={5}
            fontSize={"18px"}
            fontWeight={"500"}
            fontFamily={"roboto"}
            justifyContent={"flex-start"}
            alignItems={"center"}
            mb={4}
            key={index}
            gap={[6, 3, 3]}
          >
            <Text
              width={"35%"}
              color={"#121212"}
              fontWeight={"400"}
              lineHeight={"18.9px"}
            >
              {data?.title}
            </Text>
            <Flex width={"65%"} gap={2}>
              {data?.data ? (
                <Link
                  to={`${File_URL}${data?.data}`}
                  target="_blank"
                  style={{ color: "#D11A2A", textDecoration: "none" }}
                >
                  <Text
                    color={"#3ACB72"}
                    opacity={"0.5"}
                    lineHeight={"21.09px"}
                    textDecoration={"underline"}
                    cursor={"pointer"}
                  >
                    {data?.discription}{" "}
                  </Text>
                </Link>
              ) : (
                <Text
                  color={"#3ACB72"}
                  opacity={"0.5"}
                  lineHeight={"21.09px"}
                  textDecoration={"underline"}
                  cursor={"pointer"}
                >
                  {data?.discription}{" "}
                </Text>
              )}
              <HiDocumentText style={{ color: "#3ACB72" }} />
            </Flex>
          </Flex>
        ))}{" "}
        {!corporateDetails?.memberCategory && (
          <CorporateAproveDecline corporateDetails={corporateDetails} />
        )}
      </Box>
    </>
  );
};

export default CorporateDocuploadModal;
